var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('video',{ref:"video",staticClass:"video",attrs:{"controls":"","autoplay":"","src":!!_vm.playURL ? _vm.playURL : undefined}})])
}
var staticRenderFns = []

export { render, staticRenderFns }